<template>
  <ZMainPage type="card">
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">报名信息</span>
      </div>
      <LineWrapper labelWidth="160rem" labelAlign="right" list column="3">
        <LineItem class="item" v-for="item in list1" :key="item.label" :label="item.label" :value="item.value"></LineItem>
      </LineWrapper>
    </div>
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">缴费信息</span>
      </div>
      <LineWrapper labelAlign="right" list column="3">
        <LineItem class="item" v-for="item in list2" :key="item.label" :label="item.label" :value="item.value" :cssStyle="item.cssStyle"></LineItem>
      </LineWrapper>
    </div>
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">操作记录</span>
      </div>
      <LineWrapper labelAlign="right" list column="3">
        <LineItem class="item" v-for="item in list3" :key="item.label" :label="item.label" :value="item.value" :cssStyle="item.cssStyle"></LineItem>
      </LineWrapper>
    </div>
    <template #footer>
      <el-button @click="$router.back()">返回</el-button>
    </template>
  </ZMainPage>
</template>

<script>
import DynamicForm from '@/components/common/DynamicForm'
import LineWrapper from '@/components/common/LineWrapper'
import LineItem from '@/components/common/LineItem'
import http from '@/api'
export default {
  _config: {'route': {'path': 'detail', 'meta': {'title': '查看'}}},
  components: { DynamicForm, LineWrapper, LineItem },
  data() {
    return {
      id: '',
      loading: false,
      list1: [],
      list2: [],
      list3: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      http({ url: '/recruit-v2/offline-fresh/detail?id=' + this.$route.query.id, pre: 'zs'}).then(res => {
        const { history } = res
        this.list1 = [
          { label: '报名校区', value: res.school_name },
          { label: '入学年级', value: res.grade_name },
          { label: '入学年份', value: res.grade_year },

          { label: '学生姓名', value: res.student_name },
          { label: '学生证件类型', value: res.document_type },
          { label: '学生身份证号/护照号', value: res.student_idcard },

          { label: '学生类型', value: res.student_type },
          { label: '所属业务线', value: res.business_line },
        ]
        const list2 = [
          { label: '已缴金额  ', value: res.payment_amount },
          { label: '缴费时间', value: res.pay_time, cssStyle: {'grid-column': '2 / -1' }}
        ]
        if (res.remarks) {
          list2.push({ label: '备注', value: res.remarks, cssStyle: {'grid-column': '1 / -1' }})
        }
        this.list2 = list2
        const approve_status = history.approve_status
        const list3 = [
          { label: '录入人', value: history.creator },
          { label: '录入时间', value: history.created_at, cssStyle: {'grid-column': '2 / -1' }},
          { label: '审批状态', value: approve_status }
        ]
        if (approve_status === '待审批') {
          this.list3 = list3
          return
        }
        list3.push({ label: '审批时间', value: history.approve_at, cssStyle: {'grid-column': '2 / -1' }})
        if (approve_status === '已驳回') {
          list3.push({ label: '驳回原因', value: history.reject_reason, cssStyle: {'grid-column': '1 / -1' }})
        }
        this.list3 = list3
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
